import useShareHooks from '@/hooks/useShareHooks'
import { Button, Input } from '@nextui-org/react'
import { QRCodeSVG } from 'qrcode.react'
import { useMemo } from 'react'
import copy from 'copy-to-clipboard'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { useWeb3Modal, useWeb3ModalAccount } from '@web3modal/ethers/react'
import { formatStrAddress } from '@/utils'

import { ReactComponent as WALLET } from '@/assets/wallet/new/wallet.svg'
import { ReactComponent as METAMASK } from '@/assets/wallet/new/metamsak.svg'
import { ReactComponent as TP } from '@/assets/wallet/new/tp.svg'
import { ReactComponent as IMTOKEN } from '@/assets/wallet/new/imtoken.svg'
import { ReactComponent as MORE } from '@/assets/wallet/new/more.svg'

import BG from '@/assets/stake/invite-bg.png'

const tokens = [<WALLET />, <METAMASK />, <TP />, <IMTOKEN />, <MORE />]

export default function SharePage() {
	const { t } = useTranslation()
	const { isConnected, address } = useWeb3ModalAccount()
	const { open } = useWeb3Modal()

	const { isUserStaked } = useShareHooks().data

	const isLinkShare = useMemo(() => {
		if (isConnected) return `${window.location.origin}/#/stake?invite=${address}`
		return `${window.location.origin}/#/stake`
	}, [isConnected, address])

	return (
		<div className="relative flex w-full flex-col items-center justify-center pt-10">
			<img src={BG} alt="" className="absolute left-0 top-0 z-0 h-auto w-full" />
			<div className="relative z-10 w-full pb-5">
				<div className="flex w-full items-center justify-center pb-4">
					<span className="text-2xl font-bold text-white">{t('home.invite.title')}</span>
				</div>
				{!isConnected ? (
					<div className="flex items-center justify-center">
						<div
							onClick={() => open()}
							className="flex w-auto cursor-pointer items-center gap-3 rounded-full border border-white/[0.73] bg-[rgba(19,19,22,.07)] p-3 backdrop-blur"
						>
							{tokens.map((token, key) => (
								<div key={key}>{token}</div>
							))}
						</div>
					</div>
				) : (
					<>
						{isUserStaked ? (
							<>
								<div className="mb-8 flex w-full items-center justify-center">
									<div className="bg-[var(--theme)] p-2">
										<QRCodeSVG value={isLinkShare} width="116px" bgColor="#171232" fgColor="#fff" height="116px" />
									</div>
								</div>
								<Input
									// placeholder={isLinkShare}
									placeholder={formatStrAddress(10, 10, address || '')}
									//  value={isLinkShare} defaultValue={isLinkShare}
									classNames={{
										inputWrapper: 'tail-input-wrapper h-10',
										input: 'text-sm text-center text-white line-clamp-1 pointer-events-none	',
										base: 'opacity-100',
									}}
									readOnly
									// endContent={
									// 	<span
									// 		onClick={() => {
									// 			copy(isLinkShare)
									// 			toast.success(t('home.message.tip5'))
									// 		}}
									// 		className="z-10 shrink-0 cursor-pointer text-sm font-bold text-[#F7931A]"
									// 	>
									// 		{t('home.invite.copy')}
									// 	</span>
									// }
								/>
								<div className="flex w-full items-center justify-center">
									<Button
										onClick={() => {
											copy(isLinkShare)
											toast.success(t('home.message.tip5'))
										}}
										className="tail-btn-active mt-5 w-1/2"
									>
										<span>{t('home.invite.copy')}</span>
									</Button>
								</div>
							</>
						) : (
							<div className="mt-10 text-center text-base text-white/80">{t('home.invite.tip')}</div>
						)}
					</>
				)}
			</div>
		</div>
	)
}
